function formatHeading(text, textColorClass) {
  const splittedText = text.split('#');

  const headingType = splittedText.length - 1;
  const headingText = splittedText[splittedText.length - 1];
  return `<h${headingType} class="text-lg/8 md:text-xl/9 font-semibold mt-2 ${textColorClass}">${headingText}</h${headingType}>`;
}

function formatText(text) {
  return `<p class="text-lg/8 md:text-xl/9">${text}</p>`;
}

export default function (payload, c) {
  return payload
    .split('\n')
    .map((t) => (t.includes('#') ? formatHeading(t, c) : formatText(t)))
    .join('');
}
